import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classes from 'classnames';
import ErrorIcon from 'Components/icons/error-icon/ErrorIcon';

import Button from 'Components/Button';

import DisputesIcon from 'Components/icons/disputes-icon/DisputesIcon';
import TextField from 'Components/forms/text-field/TextField';
import TextInput from 'Components/forms/text-input/TextInput';
import InformationBubble from 'Components/information-bubble/InformationBubble';
import './ResponseBanner.scss';
import { connect } from 'react-redux';
import CloseIcon from 'Components/icons/CloseIcon/CloseIcon';
import BannerCloseIcon from 'Components/icons/BannerCloseIcon/BannerCloseIcon';
import TickIcon from 'Components/icons/TickIcon/TickIcon';
import CheckedBannerCirlceIcon from '../../icons/CheckedBannerCirlceIcon';
import SquareInformationIcon from '../../icons/SquareInformationIcon';
import Copy from '../../icons/Copy';
import { closeNotificationBanner } from 'Actions/notificationAction';
import { unLockAccountNumber } from 'Actions/accountNumberAction';
import counterpart from 'counterpart';
import { initCommonTranslate } from 'Utils/languages';

class ResponseBanner extends Component {
  renderIcon = () => {
    const { type } = this.props;
    if (type === 'dangerHPY' || type === 'danger' || type === 'dangerGPN' || type === 'blackType') {
      return <ErrorIcon acquirer={this.state.acquirerCode} />;
    } else if (type === 'warning' || type === 'blackTypeWarning') {
      return <DisputesIcon />;

    } else if (type === 'info') {
      return <SquareInformationIcon style={{ color: '#ffffff' }} />;
    } else {
      return <CheckedBannerCirlceIcon style={{ fill: 'white' }} />;
    }
  }

  constructor(props) {
    super(props);
    this.timer = 0;
    this.startTimer = this.startTimer.bind(this);
    this.countDown = this.countDown.bind(this);
    initCommonTranslate();
    let auth = JSON.parse(sessionStorage.getItem("state")).auth;
    this.state = {
      timeLeft: this.props.timeLeft,
      //       acquirerCode:JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode,
      acquirerCode: (auth !== undefined && auth.user === undefined ? "" : auth.user.acquirerCode),
    };
  }



  startTimer() {
    if (this.timer == 0 && this.state.timeLeft > 0) {
      this.timer = setInterval(this.countDown, 1000);
    }
  }

  countDown() {
    if (this.refs.timer) {
      const secondsLeft = this.state.timeLeft - 1;
      this.setState({
        timeLeft: secondsLeft,
      });

      if (secondsLeft == 0) {
        clearInterval(this.timer);
        this.props.unLockAccountNumber(false);
        this.props.closeNotificationBanner();
        this.setState({
          timeLeft: 60,
        });
      }
    }
  }

  componentWillMount() {
    this.startTimer();
  }

  render() {
    const {
      title,
      description,
      extraClass,
      type,
      descriptionHtml,
      onClose,
      bannerPosition,
      primaryButtonAction,
      extraButtonAction,
      primaryButtonText,
      secondaryButtonAction,
      secondaryButtonText,
      isSecondaryButtonActive,
      cancelButtonText,
      isSecondaryButton,
      state,
      primaryButtonActionValue,
      extraButtonActionValue,
      extraButtonText,
      secondaryButtonActionValue,
      cancelButtonActionValue,
      titleStyle,
      valueStyle,
      descriptionStyle,
      dark,
      cancelOnly,
      undoButton,
      textField,
      noActions,
      isPrimarSecondaryButtonCombo,
      successOnly,
      reportName,
      whiteLabelingFlag,
      paperlessOptIn,
      isNotificationSuccessBanner
    } = this.props;


    const componentClass = bannerPosition == "smallSizeBanner" ? 'smallSize-banner' : 'response-banner';
    const wrapperClass = classes(`${componentClass}`, {
      [type]: type,
      [extraClass]: extraClass,
    });
    const cancelSpacingClass = ['CONTINUE EDITING', 'CANCEL'].includes(cancelButtonText) ? 'cancelBtnSpacing' : '';
    const acquirer = this.state.acquirerCode;
    const hollowButtonType = type == 'danger' ? `hollow-${type}_${acquirer}` : `hollow-${type}`;
    const bodyContent = descriptionHtml !== null ? descriptionHtml : description;
    const timerText = <div ref="timer"><span>{counterpart('globalTranslate.takeAction.creditCardVisible')}</span><b> {this.state.timeLeft} {counterpart('globalTranslate.takeAction.remainingTime')}</b></div>;
    function renderPrimaryButton() {
      if (isSecondaryButtonActive && isSecondaryButton) {
        return (
          <div>
            <Button
              extraClass={type}
              category={hollowButtonType}
              action={secondaryButtonAction}
              url={secondaryButtonActionValue}
            >
              <TickIcon style={{ marginRight: 10 }} />
              {secondaryButtonText}
            </Button>
            <Button
              style={{ marginLeft: 10 }}
              extraClass={type}
              category={hollowButtonType}
              action={() => onClose(title)}
              url={cancelButtonActionValue}
            >
              {cancelButtonText}
            </Button>
          </div>
        );
      } else if (cancelOnly && !isNotificationSuccessBanner) {
        return (<div>
          <Button

            extraClass={type == 'blackType' ? `danger${acquirer}` : type}
            category={hollowButtonType}
            action={() => onClose(title)}
            url={cancelButtonActionValue}
          >
            {cancelButtonText}
          </Button>
        </div>);
      }else if (cancelOnly && isNotificationSuccessBanner) {
        return (<div>
          <Button
            id="notifications_success"
            extraClass={type == 'blackType' ? `danger${acquirer}` : type}
            category={hollowButtonType}
            action={() => onClose(title)}
            url={cancelButtonActionValue}
          >
            {cancelButtonText}
          </Button>
        </div>);
      }
      else if (successOnly) {
        return (<div>
          <Button
            extraClass={whiteLabelingFlag && acquirer =='HPY' && type=='success' ?'success':
            whiteLabelingFlag && acquirer =='HPY' && type=='dangerHPY'? 'dangerHPY':''}
            category={whiteLabelingFlag && acquirer =='HPY' && type=='success'? 'hollow-success':
            whiteLabelingFlag && acquirer =='HPY' && type=='dangerHPY'? 'hollow-danger_HPY':type}
            action={primaryButtonAction}
            url={primaryButtonActionValue}
          >
            {primaryButtonText}
          </Button>
        </div>);
      } else if (undoButton) {
        return (
          <div>
            <Button
              category={type}
              action={primaryButtonAction}
              url={primaryButtonActionValue}
            >
              {primaryButtonText}
            </Button>
            <Button
              style={{ marginLeft: 10 }}
              category={type}
              action={extraButtonAction}
              url={extraButtonActionValue}
            >
              {extraButtonText}
            </Button>
            <Button
              style={{ marginLeft: 10 }}
              extraClass={type}
              category={hollowButtonType}
              action={() => onClose(title)}
              url={cancelButtonActionValue}
            >
              {cancelButtonText}
            </Button>
          </div>
        );
      } else if (isPrimarSecondaryButtonCombo) {
        return (
          <div>
            <Button
              category={type}
              action={primaryButtonAction}
              url={primaryButtonActionValue}
            >
              {primaryButtonText}
            </Button>
            <Button
              style={{ marginLeft: 10 }}
              extraClass={`${type} ${cancelSpacingClass}`}
              category={hollowButtonType}
              action={secondaryButtonAction}
              url={cancelButtonActionValue}
            >
              {cancelButtonText}
            </Button>
          </div>
        );
      } else if (textField) {
        return (
          <div>
            <div style={{ display: 'flex' }}>
              <TextField
                fieldClass="field--fixed-width"
              >
                <TextInput
                  value={primaryButtonActionValue}
                />
              </TextField>
              <span className="copy-button">
                <InformationBubble
                  tooltipContent="Copy To Clipboard"
                  place="bottom"
                >
                  <Button
                    action={primaryButtonAction}
                    url={primaryButtonActionValue}
                    extraClass={type}
                    category={type}
                    style={{ color: '#fff' }}
                  >
                    <Copy />
                  </Button>
                </InformationBubble>
              </span>
            </div>
            <div>
              <Button
                category={hollowButtonType}
                action={() => onClose(title)}
                url={cancelButtonActionValue}
                extraClass={type}
                category={type}
                style={{ color: '#fff' }}
              >
                {cancelButtonText}
              </Button>
            </div>
          </div>
        );
      } else if (noActions) {
        return null;
      } else {
        return (
          <div>
            <Button
              category={type}
              action={primaryButtonAction}
              url={primaryButtonActionValue}
              extraClass={whiteLabelingFlag && type=='info'?`info_HPY`: type == 'warning' || 'blackTypeWarning' ? `warning_${acquirer}` : type}
            >
              {primaryButtonText}
            </Button>
            {!paperlessOptIn && (
           <Button
           style={{ marginLeft: 10 }}
            extraClass={`${cancelSpacingClass} ${
              whiteLabelingFlag && type == 'dangerHPY'
                ? 'dangerBorderButtonHPY'
                : reportName == 'MRE'
                ? 'warningMRE'
                : type == 'warning' || type == 'blackTypeWarning'
                ? `warning${acquirer}`
                : type
            }`}          
              category={hollowButtonType}
              action={() => onClose(title)}
              url={cancelButtonActionValue}
            >
              {cancelButtonText}
            </Button>
      )} 
          </div>
        );
      }
    }
    const attributes = { };
    if(title === 'Card Number Detokenized') {
      attributes['data-private'] = true
    }
    return (
      <div id="message">
        <div className={wrapperClass}>
          <div className={`${componentClass}__icon ${type}`}>
            {this.renderIcon()}

          </div>
          <div className={`${componentClass}__main`}>
            <div className={`${componentClass}__content`}>
              <div className={`${componentClass}__title`}>
                <div className={type} style={{ titleStyle }}>
                  {title}
                </div>
              </div>
              <div {...attributes} className={`${componentClass}__description ${acquirer}`}>
                <div style={descriptionStyle}>
                  {textField ? timerText : bodyContent}
                  <span>
                    <b>{textField ? '' : primaryButtonActionValue}</b>
                  </span>
                </div>

                <div style={{ paddingTop: 10 }}>{this.props.isButtonVisible && renderPrimaryButton()}</div>
              </div>
            </div>
            {
              this.props.closeIcon !== undefined || this.props.closeIcon === false ||
              <div className={`${componentClass}__close`}>
                <Button
                  extraClass={type}
                  action={() => onClose(title)}
                  extraClass={`${componentClass}__close-btn`}
                >
                  <BannerCloseIcon fill={acquirer == "HPY" ? "#203645" : "#595959"} />
                </Button>
              </div>
            }
          </div>
        </div>
      </div>
    );
  }
}

ResponseBanner.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  bannerPosition: PropTypes.string,
  type: PropTypes.string,
  extraClass: PropTypes.string,
  descriptionHtml: PropTypes.node,
  onClose: PropTypes.func,
  primaryButtonAction: PropTypes.func,
  extraButtonAction: PropTypes.func,
  cancelOnly: PropTypes.bool,
  undoButton: PropTypes.bool,
  textField: PropTypes.bool,
  isDetokenize: PropTypes.bool,
  timer: PropTypes.func,
  isButtonVisible: PropTypes.bool,
  reportName: PropTypes.string,
  whiteLabelingFlag: PropTypes.bool,
  paperlessOptIn:PropTypes.bool,
  isNotificationSuccessBanner:PropTypes.bool

};

ResponseBanner.defaultProps = {
  description: '',
  extraClass: '',
  type: '',
  cancelButtonActionValue: '',
  primaryButtonActionValue: '',
  extraButtonActionValue: '',
  descriptionHtml: null,
  dark: true,
  primaryButtonText: 'OK',
  extraButtonText: 'UNDO',
  cancelButtonText: 'CANCEL',
  cancelOnly: false,
  undoButton: false,
  textField: false,
  isDetokenize: false,
  isPrimarSecondaryButtonCombo: false,
  onClose: () => { },
  timer: () => { },
  isButtonVisible: true,
  reportName: '',
  whiteLabelingFlag: false,
  paperlessOptIn:false,
  isNotificationSuccessBanner:true
  

};


function mapDispatchToProps(dispatch) {
  return {
    closeNotificationBanner: () => dispatch(closeNotificationBanner()),
    unLockAccountNumber: (locked) => dispatch(unLockAccountNumber(locked)),
  };
}

export default connect(undefined, mapDispatchToProps)(ResponseBanner);

